<template>
  <div>
    <el-dialog title="审核" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
               :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="1200px"
               height="80%"
               @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
      <template>
        <div id="containt">
          <div style="padding: 5px 8px;">
            <el-tabs v-model="activeName">
              <el-tab-pane label="基本信息" name="first">
                <div class="" v-if="formData.stat==5">
                  <el-button type="primary" class="button-sty btn_zdy" @click="next(false)">
                    &lt;&lt;上一单
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="audit">
                    执行考核
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="open">
                    取消考核
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="next(true)">
                    下一单 &gt;&gt;
                  </el-button>
                </div>

                <div class="" v-if="formData.stat==7">
                  <el-button type="primary" class="button-sty btn_zdy" @click="next(false)">
                    &lt;&lt;上一单
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="open">
                    取消执行
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="next(true)">
                    下一单 &gt;&gt;
                  </el-button>
                </div>


                <div class="" v-if="formData.stat==2||formData.stat==3">
                  <el-button type="primary" class="button-sty btn_zdy" @click="next(false)">
                    &lt;&lt;上一单
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="open">
                    关闭
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="next(true)">
                    下一单 &gt;&gt;
                  </el-button>
                </div>

                <!-- 基本信息 -->
                <div class="d-cont edit-mce-box">
                  <div class="d-item">
                    <div class="title first"><b>主信息</b></div>
                    <table class="table-detail">
                      <tbody>
                      <tr>
                        <th>
                          <em class="f-red">*</em>
                          考核单号
                        </th>
                        <td>
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.billNo" :disabled="canBeEdited"-->
                          <!--                                    clearable/>-->
                          {{ formData.billNo }}
                        </td>
                        <th>
                          状态
                        </th>
                        <td v-if="formData.stat==1">制单</td>
                        <td v-else-if="formData.stat==2">待确认</td>
                        <td v-else-if="formData.stat==3">待申诉</td>
                        <td v-else-if="formData.stat==5">已申诉</td>
                        <td v-else-if="formData.stat==7">执行考核</td>
                        <td v-else-if="formData.stat==9">已结算</td>
                        <td v-else-if="formData.stat==19">取消执行</td>
                        <td v-else-if="formData.stat==99">关闭</td>
                        <!--                        <td>-->
                        <!--                          <el-select v-model="formData.stat" style="width: 165px;" :disabled="canBeEdited">-->
                        <!--                            <el-option label="制单" :value="1"/>-->
                        <!--                            <el-option label="待确认" :value="2"/>-->
                        <!--                            <el-option label="待申诉" :value="3"/>-->
                        <!--                            <el-option label="已申诉" :value="5"/>-->
                        <!--                            <el-option label="执行考核" :value="7"/>-->
                        <!--                            <el-option label="已结算" :value="9"/>-->
                        <!--                            <el-option label="取消执行" :value="19"/>-->
                        <!--                            <el-option label="关闭" :value="99"/>-->
                        <!--                          </el-select>-->
                        <!--                        </td>-->
                        <th>网点</th>
                        <td>
                          {{ formData.siteName }}
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.siteName"-->
                          <!--                                    :disabled="canBeEdited" clearable></el-input>-->
                        </td>
                        <!--                      <th>-->
                        <!--                        <em class="f-red">*</em>-->
                        <!--                        网点合作状态-->
                        <!--                      </th>-->
                        <!--                      <td>-->
                        <!--                        <el-select v-model="tenant.siteType3" style="width: 165px;">-->
                        <!--                          <el-option label="激活" :value="1"/>-->
                        <!--                          <el-option label="激活" :value="2"/>-->
                        <!--                          <el-option label="激活" :value="3"/>-->
                        <!--                          <el-option label="激活" :value="4"/>-->
                        <!--                        </el-select>-->
                        <!--                      </td>-->

                      </tr>
                      <tr>
                        <th>
                          机构
                        </th>
                        <td>
                          {{ formData.orgName }}
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.orgName"-->
                          <!--                                    clearable :disabled="canBeEdited"/>-->
                        </td>

                        <th>
                          关联单据
                        </th>
                        <td>
                          {{ formData.orderNo }}
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.orderNo"-->
                          <!--                                    clearable :disabled="canBeEdited"/>-->
                        </td>

                        <!--                      <th>-->
                        <!--                        <em class="f-red">*</em>-->
                        <!--                        区域结算等级-->
                        <!--                      </th>-->
                        <!--                      <td>-->
                        <!--                        <el-select v-model="tenant.stat">-->
                        <!--                          <el-option label="一二级" :value="1"/>-->
                        <!--                          <el-option label="三四级" :value="2"/>-->
                        <!--                          <el-option label="五六级" :value="3"/>-->
                        <!--                        </el-select>-->
                        <!--                      </td>-->
                      </tr>
                      <!-- <tr>
                      <th>备注</th>
                      <td colspan="7">
                        <el-input class="annotate" type="textarea" :rows="2" placeholder="请输入内容" size="small"
                          v-model="tenant.faultDescription" clearable></el-input>
                      </td>
                    </tr> -->
                      <tr>
                        <th>考核类别</th>
                        <td>
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.checkSubjectName"-->
                          <!--                                    clearable :disabled="canBeEdited"/>-->
                          {{ formData.checkSubjectName }}
                        </td>

                        <th>费用类型</th>
                        <td>
                          {{ formData.feeAttributeName }}
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.feeAttributeName"-->
                          <!--                                    clearable :disabled="canBeEdited"/>-->
                        </td>

                        <th>考核金额</th>
                        <td>
                          {{ formData.standardAmount }}
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.standardAmount"-->
                          <!--                                    clearable :disabled="canBeEdited"/>-->
                        </td>

                        <th>调整金额</th>
                        <td>
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.adjustAmount"-->
                          <!--                                    clearable :disabled="canBeEdited"/>-->
                          {{ formData.adjustAmount }}
                        </td>
                      </tr>
                      <tr>
                        <th>合计金额</th>
                        <td>
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.amount" clearable :disabled="canBeEdited"/>-->
                          {{ formData.amount }}
                        </td>

                        <th>审批金额</th>
                        <td>
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.checkAmount" clearable :disabled="canBeEdited"/>-->
                          {{ formData.checkAmount }}
                        </td>

                        <!--                      <th>-->
                        <!--                        服务属性-->
                        <!--                      </th>-->
                        <!--                      <td>-->
                        <!--                        <el-select v-model="tenant.stat">-->
                        <!--                          <el-option label="安装" :value="1"/>-->
                        <!--                          <el-option label="安装" :value="2"/>-->
                        <!--                          <el-option label="安装" :value="3"/>-->
                        <!--                        </el-select>-->
                        <!--                      </td>-->
                        <th>品牌</th>
                        <td>
                          {{ formData.brandName }}
                          <!--                          <el-input type="text" autocomplete="off" v-model="formData.brandName"-->
                          <!--                                    clearable :disabled="canBeEdited"/>-->
                        </td>

                      </tr>
                      <tr>
                        <th>考核凭证</th>
                        <td colspan="">
                          <el-image v-if="formData.proofAttachment1"
                                    :src="formData.proofAttachment1" :fit="fit" :preview-src-list="srcList"
                                    :initial-index="0"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                          <el-image v-if="formData.proofAttachment2"
                                    :src="formData.proofAttachment2" :fit="fit" :preview-src-list="srcList"
                                    :initial-index="1"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                          <el-image v-if="formData.proofAttachment3"
                                    :src="formData.proofAttachment3" :fit="fit" :preview-src-list="srcList"
                                    :initial-index="2"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>

                        </td>
                      </tr>
                      <tr>
                        <th>网点申诉凭证</th>
                        <td colspan="">
                          <el-image v-if="formData.answerAttachment1"
                                    :src="formData.answerAttachment1" :fit="fit" :preview-src-list="srcList1"
                                    :initial-index="0"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                          <el-image v-if="formData.answerAttachment2"
                                    :src="formData.answerAttachment2" :fit="fit" :preview-src-list="srcList1"
                                    :initial-index="0"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                          <el-image v-if="formData.answerAttachment3"
                                    :src="formData.answerAttachment3" :fit="fit" :preview-src-list="srcList1"
                                    :initial-index="0"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </td>
                      </tr>
                      <!--                    <tr>-->
                      <!--                      <th>总部审核凭证</th>-->
                      <!--                      <td colspan="">-->
                      <!--                        <div style="width: 165px;">-->
                      <!--                          <el-upload style="display:flex" :class="{ hide_box4: upload_btn4 }"-->
                      <!--                                     disabled="true" action="/admin/sys-file/upload"-->
                      <!--                                     :on-remove="handleRemove4" list-type="picture-card"-->
                      <!--                                     :file-list="formData.businessPhoto" :on-change="handleSuccess4"-->
                      <!--                                     :limit="3" :auto-upload="false">-->
                      <!--                            <i slot="default" class="el-icon-plus"></i>-->
                      <!--                          </el-upload>-->
                      <!--                        </div>-->
                      <!--                      </td>-->
                      <!--                    </tr>-->
                      <tr>
                        <th>考核内容</th>
                        <td colspan="7">
                          {{ formData.remark }}
                        </td>
                      </tr>
                      <tr>
                        <!--                      <th>-->
                        <!--                        <em class="f-red">*</em>-->
                        <!--                        申诉人-->
                        <!--                      </th>-->
                        <!--                      <el-input type="text" autocomplete="off" v-model="formData.siteManPid"-->
                        <!--                                clearable/>-->

                        <th>申诉时间</th>
                        <td>
                          {{ formData.siteAnswerDate }}
                        </td>
                        <th>申诉内容</th>
                        <td colspan="3">
                          {{ formData.siteAnswerNote }}
                        </td>
                      </tr>
                      <tr>
                        <th>审批人</th>
                        <td>{{ formData.checkMan }}</td>

                        <th>审批时间</th>
                        <td>
                          {{ formData.checkDate }}
                        </td>

                        <th>审批意见</th>
                        <td colspan="3">
                          {{ formData.checkNote }}
                        </td>
                      </tr>

                      <tr>
                        <th>创建人</th>
                        <td>{{ formData.createBy }}</td>
                        <th>创建时间</th>
                        <td>{{ formData.createTime }}</td>
                        <th>修改人</th>
                        <td>{{ formData.modifyBy }}</td>
                        <th>修改时间</th>
                        <td>{{ formData.modifyTime }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="操作记录" name="second">
                <div class="d-cont edit-mce-box">
                  <div class="d-item">

                    <el-table ref="filterTable" border height="535" :data="operationList" class="table_item pic_item"
                              style="width: 95%;"
                              :header-cell-style="{ background: '#F6FAFF',padding: '0',borderTop: '1px solid #eaeaea',fontSize:'12px',color:'#808080'}"
                              :header-row-style="{height:'36px'}"
                              :row-style="{height:'30px',fontSize:'12px', background: '#fff'}">
                      <!-- <el-table-column type="index" width="55">
                      </el-table-column> -->
                      <el-table-column prop="title" label="操作类型" width="100">
                      </el-table-column>
                      <el-table-column prop="content" label="操作内容" width="250">
                      </el-table-column>
                      <el-table-column prop="createBy" label="操作人" width="100">
                      </el-table-column>
                      <el-table-column prop="createTime" label="操作时间" width="150">
                      </el-table-column>

                    </el-table>
                  </div>

                </div>
              </el-tab-pane>

            </el-tabs>
          </div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
<!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogClose" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
    </el-dialog>
    <preconditionDialog3 v-if="showPreconditionDialog3" :auditData="auditData"
                         :visiable.sync="showPreconditionDialog3" multi="true" @isAudit="isAudit"/>
  </div>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'
import preconditionDialog3 from './dialog_1.vue';
import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import request from "@/router/axios";
import api from "@/api/projectApi";

export default {
  inject: ['reload'],
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'checkBillId'],
  mixins: [selectDialogMixins],
  components: {pager, preconditionDialog3},
  computed: {},
  created() {
    this.initSetting();
  },

  watch: {
    activeName: {
      handler(newVal, oldVal) {
        if (newVal !== 'first' && this.operationList.length === 0) {
          this.getHistory()
        }
      }
    },

  },
  mounted() {
    this.getData()
  },
  data() {
    return {
      canBeEdited: true,
      formData: {
        createTime: '',
        createBy: '',
        modifyBy: '',
        modifyTime: '',
        billNo: '',  // 考核单号,前缀"CK"+年月日+6位流水号
        stat: 1,  // 状态：1制单；2.待确认；3待申诉；5已申诉；7执行考核；9已结算；19取消执行；99关闭
        orgId: 0,  // 业务机构，关联脚手架机构表.id
        orgName: '',  // 机构名称,冗余字段
        orgIdPath: '',  // 机构ID路径,冗余字段.重要
        siteId: '',  // 网点ID,关联sn_user.id;
        siteName: '',  // 网点名称,冗余字段
        brandId: '',  // 品牌ID,关联sn_company_brand.id
        brandName: '',  // 品牌名称,冗余字段
        orderId: '',  // 工单id，关联so_order.id.非必填
        orderNo: '',  // 工单号，冗余字段
        settleId: 0,  // 结算单ID,关联sf_batch_settle.id字段
        checkSubjectId: '',  // 考核科目,关联bas_check_subject.id
        checkSubjectName: '',  // 考核科目
        feeAttributeId: '',  // 费用类型,关联sn_company_fee_attribute.id
        feeAttributeName: '',  // 费用类型名称,显示用
        standardAmount: '',  // 考核金额
        adjustAmount: '',  // 调整金额
        amount: '',  // 合计金额:standardAmount+adjustAmount
        proofAttachment1: '',  // 考核凭证1
        proofAttachment2: '',  // 考核凭证2
        proofAttachment3: '',  // 考核凭证3
        isNeedSiteComplain: '',  // 是否需要网点申诉:0否1是
        siteAnswerDate: '',  // 网点申诉时间
        siteAnswerNote: '',  // 网点申诉意见
        answerAttachment1: '',  // 网点申诉凭证1
        answerAttachment2: '',  // 网点申诉凭证2
        answerAttachment3: '',  // 网点申诉凭证3
        remark: '',  // 考核内容
        checkMan: '',  // 最终审批人
        checkAmount: '',  // 最终审批金额(结算时使用此金额)
        checkDate: '',  // 最终审批时间
        checkNote: '',  // 最终审批意见
      },
      operationList: [],
      auditData: {},
      srcList: [],
      srcList1: [],

      showPreconditionDialog3: false,
      activeName: 'first',
      showDialog: true,
    };
  },


  methods: {
    isAudit() {
      this.$http({
        url: api.sfCheckBill.nextDataUrl,
        method: 'post',
        data: {
          id: this.formData.id,
          stat: this.formData.stat,
          next: true
        }
      }).then(res => {
        if (res.data.data === null) {
          // this.$message.success('操作成功')
          this.dialogClose()
        } else {
          this.$message.success('操作成功, 已加载下一单')
          this.formData = res.data.data
          this.checkBillId = this.formData.id
          this.operationList = []
        }
      })
    },


    next(v) {
      this.$http({
        url: api.sfCheckBill.nextDataUrl,
        method: 'post',
        data: {
          id: this.formData.id,
          stat: this.formData.stat,
          next: v
        }
      }).then(res => {
        if (res.data.data != null) {
          this.formData = res.data.data
        } else {
          let str = v ? "当前为最后一条数据" : '当前为第一条数据'
          this.$message.warning(str)
        }
      })
    },

    audit() {
      this.auditData.id = this.formData.id
      this.auditData.siteAnswerNote = this.formData.siteAnswerNote
      this.auditData.standardAmount = this.formData.standardAmount
      this.auditData.adjustAmount = this.formData.adjustAmount
      this.auditData.amount = this.formData.amount
      this.auditData.checkAmount = this.formData.checkAmount
      this.auditData.proofAttachment1 = this.formData.proofAttachment1
      this.auditData.proofAttachment2 = this.formData.proofAttachment2
      this.auditData.proofAttachment3 = this.formData.proofAttachment3
      this.showPreconditionDialog3 = true
    },

    getHistory() {
      this.$http({
        url: api.sfCheckBillOperation.getList,
        method: 'post',
        data: {checkBillId: this.checkBillId}
      }).then(res => {
        console.log(res.data.data, '历史操作记录')
        this.operationList = res.data.data
      })
    },

    getData() {
      this.$http({
        url: api.sfCheckBill.getDataUrl,
        method: 'post',
        data: {id: this.checkBillId}
      }).then(res => {
        console.log(res.data.data, '弹窗获取数据')
        this.formData = res.data.data
        let list = []
        list.push(this.formData.proofAttachment1)
        list.push(this.formData.proofAttachment2)
        list.push(this.formData.proofAttachment3)
        this.srcList = list
        let list1 = []
        list1.push(this.formData.answerAttachment1)
        list1.push(this.formData.answerAttachment2)
        list1.push(this.formData.answerAttachment3)
        this.srcList1 = list1
      })
    },


    // 考核备注
    open() {
      let title = ''
      if (this.formData.stat == 5) {
        title = '是否取消考核'
      } else if (this.formData.stat == 7) {
        title = '是否取消执行'
      } else if (this.formData.stat == 2 || this.formData.stat == 3) {
        title = '是否关闭考核单'
      }
      this.$prompt('备注', title, {confirmButtonText: '确定', cancelButtonText: '取消',}).then(({value}) => {
        this.$http({
          url: api.sfCheckBill.cancelUrl,
          method: 'post',
          data: {
            id: this.formData.id,
            stat: this.formData.stat,
            remark: value
          }
        }).then(res => {
          this.$http({
            url: api.sfCheckBill.nextDataUrl,
            method: 'post',
            data: {
              id: this.formData.id,
              stat: this.formData.stat,
              next: true
            }
          }).then(res => {
            if (res.data.data === null) {
              this.$message.success('操作成功')
              this.dialogClose()
            } else {
              this.$message.success('操作成功, 已加载下一单')
              this.formData = res.data.data
              this.checkBillId = this.formData.id
              this.operationList = []
            }
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消操作'
        });
      });

    },

  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  width: 100px;
  height: 26px;
  border-radius: 15px;
  //   margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #ffffff !important;
  font-weight: 400;
  text-align: center;
  background-color: #00c4b3 !important;
}

// .btn_zdy:hover {
//   color: #00c4b3 !important;
//   border: 1px solid #00c4b3 !important;
// }
::v-deep .el-button--primary {
  color: #FFF;
  background-color: #00c4b3;
  border-color: #00c4b3;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
</style>
